<p-dialog [(visible)]="_display"
          [style]="{width: '17vw' , height: '72vw'}"
          position="right"
          [modal]="true"
          [baseZIndex]="10000"
          [draggable]="false"
          [resizable]="false"
          (onHide)="close()">

          <ng-template pTemplate="body">
              <div class="p-fluid">
                <div class="p-grid">
                  <div class="p-col-12">
                    <h3>Filtros</h3>
                  </div>
                </div>
              </div>

                <div class="p-grid">
                  <div class="p-col-12">
                    <p-checkbox [binary]="true"
                                label="Enviado a la ART"
                                [(ngModel)]="checkEnviados"
                                (onChange)="onChangeValue($event)">
                    </p-checkbox>
                  </div>
                </div>

              <div class="p-fluid button-filter_footer">
                <div class="p-grid">
                  <div class="p-col-12">
                    <button
                      (click)="onFilterAgendas()"
                      label="Aplicar filtros"
                      pButton
                      [disabled]="!checkEnviados">
                    </button>

                    <button
                      (click)="clearFilterAgendas()"
                      class="p-button-text"
                      label="Limpiar filtros"
                      pButton
                      type="button"
                      [disabled]="!checkEnviados">
                    </button>
                  </div>
                </div>
              </div>
          </ng-template>
</p-dialog>
